import Check from '@mui/icons-material/Check'
import Close from '@mui/icons-material/Close'
const ElementoAer = (props) => {

    const formato = 'text-center'


    return (<>
        <div className="w-full flex bg-zinc-200 flex-row justify-between" onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
            <input
                type="checkbox"
                id={props.obj.id}
                checked={props.obj.s}
                onChange={(e => props.elegir(props.obj.id))}
            />
            <div className="px-5 grid grid-cols-7 w-full">
                <label>{props.obj.empex === props.obj.empex.substring(0, 30) ? props.obj.empex : props.obj.empex.substring(0, 30) + '...'}</label>
                <label className=''>{props.obj.standnum}</label>
                <label>{props.obj.empar}</label>
                <label>{props.obj.nombrecont}</label>
                <label>{props.obj.whatcont}</label>
                <label className='flex justify-center'>
                    {props.obj.aceptado ?
                        <Check className="text-green-600" style={{ fontSize: 24 }} />
                        :
                        <Close className="text-red-600" style={{ fontSize: 24 }} />
                    }
                </label>
                <label className={formato}>{props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr), '0')}</label>
            </div>
        </div>
    </>)
}

export default ElementoAer